const locales = ['en', 'es']

export default {
    project: {
        name: process.env.VUE_APP_PROJECT_NAME || '',
        description: process.env.VUE_APP_PROJECT_DESCRIPTION || '',
    },
    isDev: process.env.NODE_ENV === 'development',
    isTest: process.env.NODE_ENV === 'test',
    useMock: process.env.VUE_APP_USE_MOCK === 'true',
    theme: {
        base: process.env.VUE_APP_THEME || 'default',
        grid: process.env.VUE_APP_GRID_THEME || 'ag-theme-material',
    },
    api: {
        baseURL: process.env.VUE_APP_API_URL,
        timeout: 30000,
        headers: {
            'Accept-Language': locales.join(', '),
            'Content-Language': process.env.VUE_APP_I18N_LOCALE || process.env.VUE_APP_I18N_FALLBACK_LOCALE,
        },
    },
    vuexPersist: {
        key: process.env.VUE_APP_PERSIST_KEY,
        modules: ['auth', 'filters'],
    },
    vueRouter: {
        base: process.env.VUE_APP_ROUTER_BASE_URL,
        mode: process.env.VUE_APP_ROUTER_USE_HASH === 'true' ? 'hash' : 'history',
    },
    i18n: {
        locale: process.env.VUE_APP_I18N_LOCALE,
        fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
        locales,
        moment: {
            en: 'en-gb',
            es: 'es',
        },
    },
    auth: {
        key: process.env.VUE_APP_AUTH_KEY,
        logoutUrl: process.env.VUE_APP_AUTH_LOGOUT_URL,
        dev: {
            user: process.env.VUE_APP_AUTH_DEV_USER || '',
            pass: process.env.VUE_APP_AUTH_DEV_PASS || '',
        },
    },
}
